import { useEffect, useState } from "react";
import { Card } from '@mui/material';
import { Avatar, Box, Button, Grid, MenuItem, Modal, TextField, Typography } from "@mui/material";
import api from "../../../../services/api";
import MessageSuccess from "../../../../messages/messageSuccess";
import MessageError from "../../../../messages/messageError";
import { useDispatch, useSelector } from "react-redux";
import HeaderGestorConfigs from "../../../../utils/headerGestorConfigs";
import ButtonLeft from "../../../../utils/buttonLeft";
import FazerObservacoes from "../../../components/fazerObservacoes.";
import { useParams } from "react-router-dom";


export default function RelatorioAnalitico({ avaliacaoAnalitica }) {
    // const { id } = useParams()
    const dispatch = useDispatch()
    const { produtoId } = useParams()
    // const navigate = useNavigate()
    const [relatorio, setrelatorio] = useState()
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [open, setOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [obs, setObs] = useState('')
    const user = useSelector(state => state.account.user);
    const [admins, setAdmins] = useState('')

    // console.log(avaliacaoAnalitica)
    useEffect(() => {
        // api.get('/admins?funcao=CNP')
        api.get('/admins?departamento=DCQMTS')
            .then(response => {
                setAdmins(response.data.Admins)
            }).catch(err => '')
    }, [])

    function HandleChange(e) {
        setrelatorio((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    }

    const submitRelatorio = async () => {

        setOpen(true)
        setMessageSuccess('')
        setMessageError('')
        // console.log(relatorio)

        await api.patch('/avalicao-analitica/emit-relatorio', {
            ...relatorio,
            comentariosConclusoes: obs,
            avaliacaoAnaliticaId: avaliacaoAnalitica?._id,
            userId: user?._id
        })
            .then(res => {
                setMessageSuccess(res.data.msg)
                setOpenModal(false)
                // navigate(-1);
                dispatch({
                    type: 'alert',
                    payload: { alert: 'Relatório Analítico emitido com sucesso!' },
                });

            }).catch(err => {
                setMessageError(err.response.data.message)
            }).finally(() => setOpen(false))
    }

    return (
        <>
            <Button
                // disabled={(produtoId && !temPermissao(user, ['controleQualidadeRelatorioAnalitico']))}
                disabled={
                    !produtoId
                    // !(
                    //     avaliacaoAnalitica?.inspeccaoVisualFisica?.resultado ||
                    //     avaliacaoAnalitica?.cromatografia?.resultado ||
                    //     avaliacaoAnalitica?.testesPH?.length > 0 ||
                    //     avaliacaoAnalitica?.testesDissolucao?.length > 0 
                    // )
                }
                fullWidth
                size="small"
                color="success"
                variant={"outlined"}
                onClick={() => setOpenModal(!openModal)}
            >
                Emitir Relatório Analítico
            </Button>

            <Modal
                open={openModal}
                onClose={() => setOpenModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                // scroll={'body'}
                sx={{ margin: 2, overflowY: "auto" }}
            >
                <Card style={{ padding: 25, maxWidth: 800, margin: 'auto' }}>
                    {messageSuccess && <MessageSuccess message={messageSuccess} />}
                    {messageError && <MessageError message={messageError} />}

                    <HeaderGestorConfigs title={'Emitir relatório analitico para este produto'} />

                    <Grid container mt={4} >
                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Substância Activa"
                                fullWidth
                                size="small"
                                name="substanciaActiva"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={relatorio?.substanciaActiva}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Concentração"
                                fullWidth
                                size="small"
                                name="concentracao"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={relatorio?.concentracao}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Resultado"
                                select
                                fullWidth
                                size="small"
                                name="resultado"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={relatorio?.resultado || ''}
                            >
                                <MenuItem value={'Aprovado'} name="resultado">
                                    Aprovado
                                </MenuItem>
                                <MenuItem value={'Reprovado'} name="resultado">
                                    Reprovado
                                </MenuItem>
                            </TextField>
                        </Grid>
                    </Grid>

                    <Grid container >
                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Local de Analise"
                                fullWidth
                                size="small"
                                name="localAnalise"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={relatorio?.localAnalise}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Grupo Terapeutico"
                                fullWidth
                                size="small"
                                name="grupoTerapeutico"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={relatorio?.grupoTerapeutico}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Condições de Armazenamento"
                                fullWidth
                                size="small"
                                name="condicoesArmazenamento"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={relatorio?.condicoesArmazenamento}
                            />
                        </Grid>
                    </Grid>

                    <Grid container >
                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="date"
                                label="Data de Ensaios"
                                fullWidth
                                size="small"
                                name="dataEnsaios"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={relatorio?.dataEnsaios}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="date"
                                label="Data de Entregue Analista"
                                fullWidth
                                size="small"
                                name="dataEntregueAnalista"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={relatorio?.dataEntregueAnalista}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />


                        </Grid>

                        <Grid xs={12} md item m={1}>
                            <TextField
                                type="text"
                                label="Titular do AIM"
                                fullWidth
                                size="small"
                                name="titularAIM"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={relatorio?.titularAIM}
                            />
                        </Grid>
                    </Grid>

                    {/* <AddAnalistaRevisor /> */}
                    <Box m>
                        <Typography>Mencionar o Analista e o Revisor</Typography>

                        <TextField
                            margin='normal'
                            required
                            type="text"
                            label="Selecionar Analista"
                            select
                            fullWidth
                            size="small"
                            name="analistaId"
                            variant="outlined"
                            onChange={HandleChange}
                            defaultValue={''}
                        >
                            {admins &&
                                admins.map((admin) => (
                                    <MenuItem key={admin._id} value={admin._id} >
                                        <Avatar src={admin.dadosPessoais?.fotoURL} style={{ marginRight: 5 }} />
                                        {admin.dadosPessoais?.nome} - <b>{admin.dadosPessoais?.provincia}, {admin.dadosPessoais?.municipio}</b>
                                    </MenuItem>
                                ))}
                        </TextField>

                        <TextField
                            margin='normal'
                            required
                            type="text"
                            label="Selecionar Revisor"
                            select
                            fullWidth
                            size="small"
                            name="revisorId"
                            variant="outlined"
                            onChange={HandleChange}
                            defaultValue={''}
                        >
                            {admins &&
                                admins.map((admin) => (
                                    <MenuItem key={admin.dadosPessoais?._id} value={admin._id} >
                                        <Avatar src={admin.dadosPessoais?.fotoURL} style={{ marginRight: 5 }} />
                                        {admin.dadosPessoais?.nome} - <b>{admin.dadosPessoais?.provincia}, {admin.dadosPessoais?.municipio}</b>
                                    </MenuItem>
                                ))}
                        </TextField>

                        <FazerObservacoes setObs={setObs} obs={obs} titulo={'Comentários e Conclusões'} />
                    </Box>

                    <ButtonLeft
                        title={'Salvar'}
                        funcao={submitRelatorio}
                        load={open}
                    >
                        {/* <Button onClick={() => navigate(-1)} color="warning" size="small" style={{ marginTop: 20, marginRight: 10 }}>Cancelar</Button> */}
                    </ButtonLeft>

                </Card>
            </Modal>
        </>
    )
}